export default __webpack_public_path__ + "static/media/0xce829a89d4a55a63418bcc43f00145adef0edb8e.3a36cd07.webp";